var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-layout-item"},[_c('collapse',{attrs:{"collapse":[_vm.storeStatusHistory.label],"is-open":false}},[_c('template',{slot:"md-collapse-pane-1"},[_c('BookingStatusHistoryTable')],1)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }